import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safevalue',
  standalone: false
})
export class SafeValuePipe implements PipeTransform {
  constructor(
    private sanitizer: DomSanitizer
  ) {
  }
  transform(value: any, opt?: string): any {
    let template = value;
    if (!value) {
      template = ``;
    }
    const reg = /href="www./g;
    template = template.toString().replace(reg, 'href="https://www.');
    template = this.sanitizer.bypassSecurityTrustHtml(template);
    return template;
  }
}
// https://stackoverflow.com/questions/31548311/angular-html-binding?rq=1
// https://angular.io/api/platform-browser/DomSanitizer
